<div style="height: auto; width: auto;">
  <canvas #chartArea></canvas>
</div>